<i18n
  src="@/locales/views/organization/partners/producers/list_producers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>

<template>
  <bread-crumbs :labels="[module_name]" />
  <template v-if="load_data_general">

    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :organization_id="organization_id"
      v-model:producers_formalized_active="producers_formalized_active"
      v-model:producers_not_formalized_active="producers_not_formalized_active"
      v-model:producers_inactive="producers_inactive"
    ></router-view>
  </template>
  <loading-message v-else />
</template>

<script>
// import Requester from "@/views/organization/requesters/partners/producers/list_producers.js";
export default {
  name: "OrgPartnersProducersListProducers",
  data() {
    return {
      load_data_formalized_active: false,
      load_data_not_formalized_active: false,
      load_data_inactives: false,
      load_data_general: false,
      option_tabs: [],
      producers_formalized_active: null,
      producers_not_formalized_active: null,
      producers_inactive: null,
    };
  },
  props: {
    organization_id: {
      required: true
    }
  },
  methods: {
    fetchData: function(){
      this.fillOptions();
      this.fetchProducers();      
      this.load_data_general = true
    },
    fetchProducers(){
      if(this.option_tabs[0].current && !this.load_data_formalized_active){
        this.fetchProducersFormalizedActive();
      }
      if(this.option_tabs[1].current && !this.load_data_not_formalized_active){
        this.fetchProducersNotFormalizedActive();
      }
      if(this.option_tabs[2].current && !this.load_data_inactives){
        this.fetchProducersInactive();
      }
    },
    fetchProducersFormalizedActive: async function () {
      // let response = await Requester.fetchProducersFormalizedActive(this.organization_id);
      // this.producers_formalized_active = response.data;
      this.load_data_formalized_active = true;
    },
    fetchProducersNotFormalizedActive: async function () {
      // let response = await Requester.fetchProducersNotFormalizedActive(this.organization_id);
      // this.producers_not_formalized_active = response.data;
      this.load_data_not_formalized_active = true;
    },
    fetchProducersInactive: async function () {
      // let response = await Requester.fetchProducersInactive(this.organization_id);
      // this.producers_inactive = response.data;
      this.load_data_inactives = true;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.formalized_active_title"),
          icon: "fa-solid fa-user-check",
          route: { name: this.routeName("list_producers_formalized_active") },
          current: true
        },
        {
          name: this.$t("labels.not_formalized_active_title"),
          icon: "fa-solid fa-user-minus",
          route: { name: this.routeName("list_producers_not_formalized_active") }
        },
        {
          name: this.$t("labels.inactive_title"),
          icon: "fa-solid fa-ban",
          route: { name: this.routeName("list_producers_inactive") }
        }
      ];
    }
  },
  watch: {
    option_tabs: function () {
      this.fetchProducers();
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.fetchData())
    );
  }
};
</script>
